import { activeGameId } from "../profile_management/selectors";
import getDownloadPath from "./util/getDownloadPath";
import { createCachedSelector } from "re-reselect";
import { createSelector } from "reselect";
const downloadPathPattern = (state) => state.settings.downloads.path;
export const downloadPath = createSelector(downloadPathPattern, activeGameId, (inPath, inGameId) => getDownloadPath(inPath, inGameId));
const downloadPathForGameImpl = createCachedSelector(downloadPathPattern, (state, gameId) => gameId, (inPath, gameId) => getDownloadPath(inPath, gameId))((state, gameId) => gameId);
export function downloadPathForGame(state, gameId) {
    return downloadPathForGameImpl(state, gameId ?? activeGameId(state) ?? "__invalid");
}
const downloadFiles = (state) => state.persistent.downloads.files;
export const downloadsForGame = (state, gameId) => {
    return Object.keys(downloadFiles(state)).reduce((prev, id) => {
        const download = downloadFiles(state)[id];
        if (download.game.includes(gameId) &&
            ["finished"].includes(download.state)) {
            prev[id] = download;
        }
        return prev;
    }, {});
};
export const downloadsForActiveGame = (state) => createSelector(activeGameId, (inGameId) => downloadsForGame(state, inGameId));
const ACTIVE_STATES = ["finalizing", "started"];
const QUEUE_CLEAR_STATES = ["started", "paused", "init"];
export const queueClearingDownloads = createSelector(downloadFiles, (files) => Object.keys(files).reduce((prev, id) => {
    if (QUEUE_CLEAR_STATES.includes(files[id].state)) {
        prev[id] = files[id];
    }
    return prev;
}, {}));
export const activeDownloads = createSelector(downloadFiles, (files) => Object.keys(files).reduce((prev, id) => {
    if (ACTIVE_STATES.includes(files[id].state)) {
        prev[id] = files[id];
    }
    return prev;
}, {}));
export const getDownloadByIds = createSelector(downloadFiles, (state, identifiers) => identifiers, (files, identifiers) => {
    return Object.values(files).find((dl) => {
        if (dl.game.includes(identifiers.gameId) === false) {
            return false;
        }
        return (dl.modInfo?.nexus?.ids?.fileId === identifiers.fileId &&
            dl.modInfo?.nexus?.ids?.modId === identifiers.modId);
    });
});
